module.exports = __webpack_public_path__ + "images/favicon-96.38f2bd6792e27ef08bd26b13c5fe6c8c.png";